import { useEffect, useState } from "react";

export const OPTIONS_PAGE_SIZE = 50;

export const usePagedOptions = <Item>(skip: number, page: Item[] | undefined, total?: number) => {
  const [loaded, setLoaded] = useState<{ items: Item[]; count?: number }>({ items: [] });

  useEffect(() => {
    if (!page) return;
    setLoaded((previous) => {
      const items = [...previous.items.slice(0, skip), ...page];
      return { items, count: total ?? (page.length < OPTIONS_PAGE_SIZE ? items.length : undefined) };
    });
  }, [page, total, skip]);

  return loaded;
};
